export const ScreenLoading = () => (
  <div className="animate-fade-in opacity-0 [animation-delay:1000ms]">Loading...</div>
)
